import React from 'react';
import PropTypes from 'prop-types';

/**
 * Kompakte Kennzahl, senkrecht gestapelt (Okt 2026, wie die vier Kennzahlen
 * im Lernlogbuch des Werbespots, Motion-Kit `.eo-mini`): Icon, Wert, Label.
 * Vier passen nebeneinander auf ein Telefon.
 *
 * Neutral; nur `accent="aura"` faerbt das Icon — Aura ist die Marke.
 * `value` darf ein Knoten sein (z.B. <AnimatedNumber>).
 */
const MiniStat = ({ icon: Icon, value, label, accent, className = '' }) => (
  <div className={`min-w-0 rounded-lg border border-border bg-surface-raised px-2.5 py-[9px] ${className}`}>
    {Icon && (
      <Icon
        className={`mb-[5px] h-3.5 w-3.5 ${accent === 'aura' ? 'text-primary' : 'text-faint'}`}
        aria-hidden="true"
      />
    )}
    <div className="truncate text-title-s font-semibold leading-tight text-foreground tabular-nums">{value}</div>
    <div className="text-2xs leading-tight text-muted-foreground">{label}</div>
  </div>
);

MiniStat.propTypes = {
  icon: PropTypes.elementType,
  value: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  accent: PropTypes.oneOf(['aura']),
  className: PropTypes.string,
};

export default MiniStat;
